import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext.js';
import { $insertNodeToNearestRoot } from '@lexical/utils';
import { COMMAND_PRIORITY_EDITOR } from 'lexical';
import { useEffect } from 'react';
import { $createAdminComponentNode, INSERT_ADMIN_COMPONENT_COMMAND } from './AdminComponentNode.js';
export function ComponentPlugin() {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        return editor.registerCommand(INSERT_ADMIN_COMPONENT_COMMAND, (payload) => {
            const node = $createAdminComponentNode(payload);
            $insertNodeToNearestRoot(node);
            return true;
        }, COMMAND_PRIORITY_EDITOR);
    }, [editor]);
    return null;
}
//# sourceMappingURL=ComponentPlugin.js.map